<template>
  <div class='alarmInfo-wrap'>
    <p class="title">{{name}}</p>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%" size="mini" empty-text="暂无设备信息">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="displayName" label="设备信息"></el-table-column>
        <el-table-column prop="state" label="状态" width="50" align="center">
          <template slot-scope="scope">
            <span class="state" :style="{background:scope.row.pointNumber == 0 ? '#3d8839' : '#d7261d'}"></span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="描述" width="50" align="center">
          <template slot-scope="scope">
            <span class="info">{{scope.row.pointNumber == 0?'开':'关'}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlarmInfo",
  props: {
    name: {
      type: String,
      default: ""
    },
    alarmInfo: {
      type: Array,
      default: []
    },
    ids: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  mounted () {
    this.getMeasuresExpressions();
  },
  methods: {
    async getMeasuresExpressions () {
      let result = await this.$api.measure.getUniqueMeasuresExpressions(JSON.stringify(this.ids));
      if (result.success) {
        //let data = result.data[0].expressionGroups[0].expression;
        result.data[0].expressionGroups.map(tempData => {
          let data = tempData.expression;
          let pointCodeData = data.filter(item => item.pointCode == 601);
          this.tableData = JSON.parse(JSON.stringify(pointCodeData));
          /* console.log(pointCodeData);
          this.alarmInfo.map(i => {
              let temp = pointCodeData.find(j => j.pointNumber == i.pointNum);
              temp && this.tableData.push(temp);
          }); */
        })
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.alarmInfo-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  border-radius: 4px;
  .title {
    font-weight: bold;
    color: #2e3842;
    height: 30px;
    line-height: 30px;
    background: #3f9efe;
    padding: 0px 10px;
    box-sizing: border-box;
  }
  .table {
    flex: 1;
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    .state {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 16px;
      background: #3d8839;
      margin-top: 4px;
    }
  }
}
</style>